// @flow
import React, { Component } from 'react';
import { Button, Header, Form, Message, Loader, Label, Input } from 'semantic-ui-react';
import { assign, filter, first, keys, map, isEqual, merge } from 'lodash';
import { parse } from 'query-string';
import SaveFilterModal from '../molecules/SaveFilterModal';
import FloatingActionsHover from '../molecules/FloatingActionsHover';
import { getGridFilter, previewFilter, getReportFilter } from '../../modules/client';
import type { LocationShape, Match, RouterHistory } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
const { columnTypes } = require('../../modules/columnTypes');

class Poseidon extends Component<
    {
        history: RouterHistory,
        location: LocationShape,
        match: { params: { gridId: ?Guid, filterId: Guid, reportId: ?Guid } },
        onEditFilter: (
            gridId: Guid,
            filterId: Guid,
            filterDefinition: { [string]: string[] },
            filterName: string,
            clientId: Guid
        ) => Promise<void>
    },
    {
        columnDefinitions: any[],
        data: any[],
        editName: boolean,
        error: string,
        filterDefinition: { [string]: string[] },
        filterName: string,
        filterOptions: any,
        loading: boolean,
        saveFilterModal: boolean
    }
> {
    constructor() {
        super();
        this.state = {
            columnDefinitions: [],
            data: [],
            editName: false,
            error: '',
            filterDefinition: {},
            filterName: '',
            filterOptions: {},
            loading: true,
            saveFilterModal: false
        };
    }
    gridApi: ?GridApi = null;
    gridColumnApi: ?ColumnApi = null;
    componentDidMount() {
        this.getGridData();
    }
    getGridData() {
        const { filterId, reportId, gridId } = this.props.match.params;
        const currentQuery = parse(this.props.location.search || '');
        const clientId = currentQuery.clientId;
        const getData = () =>
            reportId ? getReportFilter(filterId, clientId) : getGridFilter(filterId, clientId);

        getData().then(
            ({ data, filterName, filterDefinition, columnDefinitions, ...rest }) => {
                filterDefinition = JSON.parse(filterDefinition);
                const colDefs = columnDefinitions.map(colDef => {
                    let filterParams = [];
                    if (colDef.field) {
                        filterParams = rest[colDef.field];
                    }
                    const type = columnTypes[colDef.type];
                    return merge(
                        assign(colDef, {
                            filterParams: { values: filterParams.map(option => option.value) }
                        }),
                        type
                    );
                });
                this.setState({
                    data: data,
                    filterName: filterName,
                    filterDefinition: filterDefinition,
                    filterOptions: rest,
                    columnDefinitions: colDefs,
                    loading: false
                });
            },
            (err: Error) => this.setState({ error: err.message })
        );
    }
    onSave() {
        const { gridId, filterId } = this.props.match.params;
        const currentQuery = parse(this.props.location.search || '');
        const clientId = currentQuery.clientId;
        if (gridId) {
            this.props
                .onEditFilter(
                    gridId,
                    filterId,
                    this.state.filterDefinition,
                    this.state.filterName,
                    clientId
                )
                .catch(err => console.error(err));
        }
    }
    setFilter = (e: RowEvent) => {
        const filterModel = e.api.getFilterModel();
        const filterChanged = !isEqual(filterModel, this.state.filterDefinition);
        if (filterChanged) {
            const filterId = this.props.match.params.filterId;
            const currentQuery = parse(this.props.location.search || '');
            const clientId = currentQuery.clientId;
            e.api.showLoadingOverlay();
            this.setState({ filterDefinition: filterModel }, () =>
                previewFilter(filterId, clientId, JSON.stringify(this.state.filterDefinition)).then(
                    data => {
                        this.setState({ data });
                        e.api.setFilterModel(this.state.filterDefinition);
                    }
                )
            );
        }
    };
    onGridReady = (params: GridReadyEvent) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.setFilterModel(this.state.filterDefinition);
        if (this.gridApi) {
            this.gridApi.sizeColumnsToFit();
        }
    };
    render() {
        const {
            data,
            filterName,
            filterDefinition,
            columnDefinitions,
            filterOptions,
            loading,
            editName
        } = this.state;
        const actionOptions = [
            { icon: 'check', onClick: () => this.setState({ saveFilterModal: true }) },
            { color: 'grey', icon: 'undo', onClick: () => this.props.history.goBack() }
        ];
        const defaultColDef = {
            editable: false,
            filter: 'text'
        };
        if (loading) {
            return <Loader active size="large">{`Loading Grids...`}</Loader>;
        }
        if (this.gridApi) {
            this.gridApi.hideOverlay();
        }
        if (data && data.length == 0 && this.gridApi) {
            this.gridApi.showNoRowsOverlay();
        }
        return (
            <div className="ag-bootstrap">
                <Form error={this.state.error.length !== 0}>
                    <div className="flex u-medium-marginbottom">
                        <div className="flex-1">
                            <Header as="h2" className="c-page-header">
                                Edit Filter
                                {editName ? (
                                    <Form
                                        onSubmit={e =>
                                            this.setState({
                                                editName: false
                                            })
                                        }
                                    >
                                        <Input
                                            name="filterName"
                                            action
                                            type="text"
                                            size="huge"
                                            value={filterName}
                                            onChange={(e, { value }) => {
                                                this.setState({ filterName: value });
                                            }}
                                        >
                                            <input />
                                            <Button type="submit" content="Save" />
                                        </Input>
                                    </Form>
                                ) : (
                                    <Header.Subheader>
                                        <Label
                                            as="a"
                                            size="massive"
                                            onClick={() => this.setState({ editName: true })}
                                        >
                                            {filterName}
                                        </Label>
                                    </Header.Subheader>
                                )}
                            </Header>
                        </div>
                    </div>
                    {data ? (
                        <AgGridReact
                            id="Poseidon"
                            columnDefs={columnDefinitions}
                            defaultColDef={defaultColDef}
                            columnTypes={columnTypes}
                            enableFilter={true}
                            floatingFilter={true}
                            rowData={data}
                            domLayout="autoHeight"
                            onGridReady={this.onGridReady.bind(this)}
                            onFilterChanged={this.setFilter}
                        />
                    ) : null}
                    <Message content={this.state.error} error />
                </Form>

                <FloatingActionsHover options={actionOptions} />

                <SaveFilterModal
                    onCancel={() => this.setState({ saveFilterModal: false })}
                    onConfirm={() => this.onSave()}
                    open={this.state.saveFilterModal}
                />
            </div>
        );
    }
}

export default Poseidon;



// WEBPACK FOOTER //
// ./components/pages/Poseidon.jsx